<!-- Main container for the vehicle parking management interface -->
<main tuiNavigationMain [style.border]="'0px!important'">
  <!-- Header section with title and description -->
  <div [style.grid-column]="'2 / span 10'" [style.margin-top.rem]="1" [style.paddingTop.rem]="1">
    <header tuiHeader="h4">
      <hgroup tuiTitle>
        <h4 [tuiSkeleton]="skeleton && 10">{{ skeleton ? '' : 'Team Management' }}</h4>
        <p tuiSubtitle [tuiSkeleton]="skeleton && 15">{{ skeleton ? '' : 'Manage team members and view their active
          devices' }}</p>
      </hgroup>
    </header>
    <hr />
  </div>

  <div [style.grid-column]="'2 / span 10'">
    <div tuiAppearance="outline-grayscale" tuiCardLarge tuiForm="m" [style.borderRadius.rem]="0.75"
      [style.margin-top.rem]="1.1">
      <div class="flex gap-4 justify-between">
        <!-- Left: Seats info -->
        <div class="flex-1">
          <form [formGroup]="vehicleSelectionForm" class="flex" style="align-items: center; gap: 0.75rem;">
            <div>
              <p tuiSubtitle [tuiSkeleton]="skeleton && 20">
                <b>Seats:</b> {{ skeleton ? '' : roleDisplayTextSignal() }}
              </p>
            </div>
            <!-- Limit-reached warning badge -->
            <tui-badge *ngIf="!skeleton && isUserLimitReached" appearance="warning" style="font-size: 0.7rem;">
              Limit reached
            </tui-badge>
          </form>
        </div>

        <!-- Right: Add member button -->
        <div class="flex-1">
          <button iconStart="@tui.plus" tuiTextfieldSize="s" size="m" tuiButton type="button"
            [appPermissionDisable]="'Team & Access Control'" [appPermissionAction]="'create'"
            [appPermissionSubModule]="'Team'" [disabled]="isUserLimitReached"
            [tuiHint]="isUserLimitReached ? 'User limit reached. Upgrade your plan to add more members.' : ''"
            (click)="openInviteDrawer()" [tuiSkeleton]="skeleton">
            Add Member
          </button>
          <app-drawer-invite-team-member #drawerComponent [showParkingDropdown]="false" [parkingId]="contextParkingId"
            (teamMembersCreated)="onTeamMembersCreated()"></app-drawer-invite-team-member>
        </div>
      </div>



    </div>

    <!-- Data content -->
    <div *ngIf="(!loading() || skeleton) && !error()" tuiAppearance="outline-grayscale" tuiCardLarge tuiForm="m"
      [style.margin-top.rem]="1.25" [style.width.%]="100" [style.borderRadius.rem]="0.75" [style.padding-bottom.px]="12"
      [style.overflow]="'clip!important'" [style.margin-bottom.rem]="2.25">
      <button tuiCardLarge tuiCell tuiSurface="floating" type="button" [style.paddingLeft.rem]=".7"
        [style.width.%]="102">
        <tui-avatar appearance="custom" [style.background-color]="'var(--tui-background-neutral-1)'"
          [style.color]="'var(--tui-text-primary)'" class="vehicle-icon" [tuiSkeleton]="skeleton">
          <img src="assets/images/icons/modules/Team.svg" alt="team" />
        </tui-avatar>
        <div tuiTitle [style.width.%]="100" [style.margin-inline-start]="0">
          <div class="flex">
            <div class="flex-1">
              <span style="font-weight: var(--bold);" [tuiSkeleton]="skeleton && 10">{{ skeleton ? '' : 'Members'
                }}</span>
              <!-- Pricing summary subtitle -->
              <div tuiSubtitle style="margin-inline-start: 0;" [tuiSkeleton]="skeleton && 20">
                <span *ngIf="!skeleton">
                  {{ filteredData().length }} members
                  <ng-container *ngIf="count()">
                    • ({{ count() }}) Filtered applied
                  </ng-container>
                </span>
                <span *ngIf="!skeleton">• Sorted by CREATED AT</span>
              </div>
            </div>
            <div class="flex-1 gapo">
              <!--<button iconStart="@tui.download" tuiIconButton type="button" size="m" appearance="secondary"
                [appPermissionDisable]="'Team & Access Control'" [appPermissionAction]="'read'"
                [appPermissionSubModule]="'Team'" (click)="exportData()" [tuiSkeleton]="skeleton">
      </button>-->
            </div>
          </div>
        </div>
      </button>

      <div class="filters-teams">
        <search tuiSearch [style.width]="'fit-content'">
          <form [formGroup]="form" (ngSubmit)="applyFilters()">
            <fieldset tuiTextfieldSize="s">
              <tui-textfield iconStart="@tui.search" [tuiSkeleton]="skeleton">
                <input formControlName="search" placeholder="Search members..." tuiTextfield
                  (keyup.enter)="applyFilters()" />
              </tui-textfield>
              <tui-textfield tuiChevron [tuiSkeleton]="skeleton">
                <select formControlName="statusFilter" placeholder="Status" tuiTextfield>
                  <option value="">All Status</option>
                  <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
                </select>
                <tui-data-list-wrapper *tuiTextfieldDropdown [items]="statusOptions"
                  [style.min-width]="dropdownWidths['status']" />
              </tui-textfield>
              <tui-textfield tuiChevron [tuiSkeleton]="skeleton">
                <select formControlName="roleFilter" placeholder="Role" tuiTextfield>
                  <option value="">All Roles</option>
                  <option *ngFor="let role of roleOptions" [value]="role">{{ role }}</option>
                </select>
                <tui-data-list-wrapper *tuiTextfieldDropdown [items]="roleOptions"
                  [style.min-width]="dropdownWidths['role']" />
              </tui-textfield>
              <button size="s" tuiButton type="button" [appPermissionDisable]="'Team & Access Control'"
                [appPermissionAction]="'read'" [appPermissionSubModule]="'Team'" (click)="applyFilters()"
                [tuiSkeleton]="skeleton">
                Apply
              </button>
              <button [style.height.px]="32" [style.borderRadius.px]="6" appearance="flat" iconStart="@tui.rotate-cw"
                size="xs" tuiButton type="button" (click)="clearFilters()" [disabled]="!hasActiveFilters()"
                [tuiSkeleton]="skeleton">
                Clear Filters{{ count() ? '(' + count() + ')' : '' }}
              </button>
            </fieldset>

          </form>
        </search>

      </div>

      <!-- Skeleton Table -->
      <table *ngIf="skeleton" tuiTable size="s" [style.width.%]="100">
        <thead>
          <tr tuiThGroup>
            <th tuiTh [style.width.%]="1"><div class="skeleton-bar" style="width: 16px;"></div></th>
            <th tuiTh><div class="skeleton-bar" style="width: 60px;"></div></th>
            <th tuiTh><div class="skeleton-bar" style="width: 40px;"></div></th>
            <th tuiTh *ngIf="isAdminUser()"><div class="skeleton-bar" style="width: 60px;"></div></th>
            <th tuiTh><div class="skeleton-bar" style="width: 80px;"></div></th>
            <th tuiTh><div class="skeleton-bar" style="width: 60px;"></div></th>
            <th tuiTh><div class="skeleton-bar" style="width: 60px;"></div></th>
            <th tuiTh></th>
          </tr>
        </thead>
        <tbody tuiTbody>
          <!-- Skeleton Dummy Rows when loading -->
          <tr *ngFor="let rowIdx of [1, 2, 3, 4, 5]" class="skeleton-row">
            <td tuiTd [style.padding-right.rem]="0">
              <div class="skeleton-cell skeleton-cell-default">
                <div class="skeleton-bar" [style.width]="'16px'" [style.animation-delay.ms]="rowIdx * 100"></div>
              </div>
            </td>
            <td tuiTd>
              <div class="skeleton-cell skeleton-cell-name">
                <div class="skeleton-avatar" [style.animation-delay.ms]="rowIdx * 100"></div>
                <div class="skeleton-text-group">
                  <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100"></div>
                  <div class="skeleton-bar skeleton-bar-sub" [style.animation-delay.ms]="rowIdx * 100 + 50"></div>
                </div>
              </div>
            </td>
            <td tuiTd>
              <div class="skeleton-cell skeleton-cell-two-line">
                <div class="skeleton-text-group">
                  <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100"></div>
                  <div class="skeleton-bar skeleton-bar-sub" [style.animation-delay.ms]="rowIdx * 100 + 50"></div>
                </div>
              </div>
            </td>
            <td tuiTd *ngIf="isAdminUser()">
              <div class="skeleton-cell skeleton-cell-badge">
                <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100" [style.width]="'60px'"></div>
              </div>
            </td>
            <td tuiTd>
              <div class="skeleton-cell skeleton-cell-default">
                <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100" [style.width]="'120px'"></div>
              </div>
            </td>
            <td tuiTd>
              <div class="skeleton-cell skeleton-cell-chips" [style.flex-direction]="'row'">
                <div class="skeleton-avatar" [style.animation-delay.ms]="rowIdx * 100" [style.width]="'16px'" [style.height]="'16px'"></div>
                <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100" [style.width]="'60px'"></div>
              </div>
            </td>
            <td tuiTd>
              <div class="skeleton-cell skeleton-cell-badge">
                <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100" [style.width]="'60px'"></div>
              </div>
            </td>
            <td tuiTd>
              <div class="skeleton-cell skeleton-cell-action">
                <div class="skeleton-bar" [style.animation-delay.ms]="rowIdx * 100"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Actual Data Table -->
      <table *ngIf="!skeleton" tuiTable size="s" [style.width.%]="100">
        <caption tuiCaption>
          <span>{{ filteredData().length }} rows</span>
          <button appearance="flat" tuiButton type="button" [tuiDropdown]="pageSizeDropdown" [tuiDropdownManual]="false"
            [tuiDropdownOpen]="isPageSizeDropdownOpen"
            (click)="togglePageSizeDropdown(); $event.preventDefault(); $event.stopPropagation();">
            {{ index * size + 1 }}-{{ Math.min((index + 1) * size, filteredData().length) }} of {{ filteredData().length
            }}
            <ng-template #pageSizeDropdown>
              <tui-data-list tuiDataListDropdownManager [size]="'s'">
                <button *ngFor="let sizeOption of pageSizeOptions" tuiOption type="button"
                  (click)="onPageSizeChange(sizeOption)">
                  {{ sizeOption }}
                </button>
              </tui-data-list>
            </ng-template>
          </button>
          <tui-pagination [length]="Math.ceil(filteredData().length / size)" [style.float]="'right'" [(index)]="index" />
        </caption>
        <thead>
          <tr tuiThGroup>
            <th tuiTh [style.width.%]="1">#</th>
            <th tuiTh>MEMBER</th>
            <th tuiTh>ROLE</th>
            <th tuiTh *ngIf="isAdminUser()">ACCESS</th>
            <th tuiTh>LAST LOGIN</th>
            <th tuiTh>DEVICES</th>
            <th tuiTh>STATUS</th>
            <th tuiTh></th>
          </tr>
        </thead>
        <tbody tuiTbody>
            <tr *ngFor="let item of filteredData() | slice: index * size : (index + 1) * size; let i = index">
              <td tuiTd [style.padding-right.rem]="0">
                <span>{{ index * size + i + 1 }}</span>
              </td>
              <td tuiTd>
                <button tuiCardLarge tuiCell tuiSurface="floating" type="button" class="member-row-card"
                  [style.paddingLeft.rem]=".7" [style.width.%]="100">
                  <tui-avatar appearance="custom" [style.background-color]="'var(--tui-background-neutral-1)'"
                    [style.color]="'var(--tui-text-primary)'" [size]="'m'" class="vehicle-icon"
                    [tuiSkeleton]="skeleton">
                    <tui-avatar [src]="item.avatar || (item.name | userInitials)"
                      [style.background-color]="'var(--tui-background-neutral-1)'"
                      [style.color]="'var(--tui-text-secondary)'" size="m" />
                  </tui-avatar>
                  <div [style.width.%]="100" [style.margin-inline-start]="0">
                    <div class="flex">
                      <div class="flex-1">
                        <b [tuiSkeleton]="skeleton" [style.font-weight]="'var(--medium)'"
                          [style.font]="'var(--tui-font-text-ui-s)'">{{ item.name
                          }}</b>
                        <!-- Pricing summary subtitle -->
                        <div tuiSubtitle style="margin-inline-start: 0;">
                          <span [tuiSkeleton]="skeleton">{{ item.email || item.phone }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
              </td>
              <td tuiTd>
                <div>
                  <!-- <tui-chip size="xs" appearance="neutral">{{ item.role }}</tui-chip> -->
                  <button tuiCardLarge tuiCell tuiSurface="floating" type="button" class="member-row-card"
                    [style.paddingLeft.rem]=".7" [style.width.%]="100">

                    <div [style.width.%]="100" [style.margin-inline-start]="0">
                      <div class="flex">
                        <div class="flex-1" (mouseenter)="showParkingTooltip($event, item, false)"
                          (mouseleave)="hideParkingTooltip()" [style.width]="'fit-content'">
                          <b [style.font-weight]="'var(--medium)'" [style.font]="'var(--tui-font-text-ui-s)'"
                            [tuiSkeleton]="skeleton">{{ item.role
                            }}</b>
                          <!-- Pricing summary subtitle -->
                          <div tuiSubtitle style="margin-inline-start: 0;">
                            <span [tuiSkeleton]="skeleton">{{ getAccessTypeText(item) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>
              </td>
              <td tuiTd *ngIf="isAdminUser()">
                <!-- {{ item.parkingName || 'All Parkings' }} -->
                <div *ngIf="getParkingAssignmentCount(item) !== '-'" class="parking-chip-container"
                  (mouseenter)="showParkingTooltip($event, item)" (mouseleave)="hideParkingTooltip()"
                  [style.cursor]="'pointer'" [tuiSkeleton]="skeleton">
                  <tui-chip size="xs" appearance="neutral">
                    {{ getParkingAssignmentCount(item) }}
                  </tui-chip>
                </div>
                <span *ngIf="getParkingAssignmentCount(item) === '-'" [tuiSkeleton]="skeleton && 4">-</span>
              </td>
              <td tuiTd>
                <span [tuiSkeleton]="skeleton">{{ item.lastLogin | formatUTCToOrgTimezone:'d MMM yyyy, h:mm a' }}</span>
              </td>
              <td tuiTd [appPermissionDisable]="'Team & Access Control'" [appPermissionAction]="'read'"
                [appPermissionSubModule]="'Team'" (click)="openDevicesModal(item)" style="cursor:pointer;">
                <div class="device-flex">
                  <tui-icon icon="@tui.eye" [style.font-size.rem]="1" [tuiSkeleton]="skeleton" />
                  <span [tuiSkeleton]="skeleton">{{ item.devices }}</span> <span [style.font-weight]="'var(--medium)'"
                    [tuiSkeleton]="skeleton">Devices</span>
                </div>
              </td>
              <td tuiTd>
                <span
                  [tuiStatus]="item.status === 'Active' ? 'var(--tui-status-positive)' : item.status === 'Pending' ? 'var(--tui-status-neutral)' : 'var(--tui-status-negative)'"
                  [tuiSkeleton]="skeleton">
                  {{ item.status }}
                </span>
              </td>
              <td tuiTd>
                <div class="flex items-center justify-end">
                  <!-- <input tuiSwitch type="checkbox" [ngModel]="item.isActive" [showIcons]="false"
                    [size]="getSwitchSize()" [appPermissionDisable]="'Team & Access Control'"
                    [appPermissionAction]="'update'" [appPermissionSubModule]="'Team'"
                    (ngModelChange)="toggleMemberStatus(item, $event)" [tuiSkeleton]="skeleton" /> -->

                  <div class="table-action">
                    <button appearance="flat" iconStart="@tui.ellipsis-vertical" tuiIconButton type="button"
                      *ngIf="hasMemberActions(item)" [appPermissionDisable]="'Team & Access Control'"
                      [appPermissionAction]="'read'" [appPermissionSubModule]="'Team'" [tuiDropdown]="actionDropdown"
                      [tuiDropdownManual]="false" [tuiDropdownOpen]="isOpen(item.name)"
                      (click)="toggleDropdown(item.name); $event.preventDefault();" [tuiSkeleton]="skeleton">
                    </button>

                    <ng-template #actionDropdown>
                      <tui-data-list tuiDataListDropdownManager size="m">
                        <!-- <button tuiOption type="button" (click)="onActio nClick('View', item)">View</button> -->
                        <button *ngIf="canEditMember(item)" tuiOption type="button"
                          (click)="onActionClick('Edit', item)" [appPermissionDisable]="'Team & Access Control'"
                          [appPermissionAction]="'update'" [appPermissionSubModule]="'Team'">Edit</button>
                        <button *ngIf="canChangeMemberStatus(item) && getStatusActionLabel(item) !== 'Suspend'"
                          tuiOption type="button" (click)="onActionClick(getStatusActionLabel(item), item)"
                          [appPermissionDisable]="'Team & Access Control'" [appPermissionAction]="'update'"
                          [appPermissionSubModule]="'Team'">{{ getStatusActionLabel(item) }}</button>
                        <button tuiOption type="button" (click)="onActionClick('ChangePassword', item)"
                          [appPermissionDisable]="'Team & Access Control'" [appPermissionAction]="'update'"
                          [appPermissionSubModule]="'Team'">Change Password</button>
                        <button *ngIf="canDeleteMember(item)" tuiOption type="button"
                          (click)="onActionClick('Remove', item)" [appPermissionDisable]="'Team & Access Control'"
                          [appPermissionAction]="'delete'" [appPermissionSubModule]="'Team'"
                          [style.color]="'var(--tui-status-negative)'">Remove</button>
                      </tui-data-list>
                    </ng-template>
                  </div>
                </div>
              </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>




  <!-- Devices Modal Drawer -->
  <app-devices-drawer #devicesDrawer></app-devices-drawer>


  <div #tooltipEl class="custom-tooltip" [class.show]="tooltipVisible" [style.left.px]="tooltipPosition.x"
    [style.top.px]="tooltipPosition.y">
    <div class="tooltip-content">

      <div class="tooltip-body">
        <div *ngIf="tooltipParkingList.length > 0" class="parking-list">
          <div *ngFor="let parking of tooltipParkingList" class="parking-item">
            <tui-icon icon="@tui.map-pin-check" class="parking-icon"></tui-icon>
            <span>{{ parking.name || parking.id }}</span>
          </div>
        </div>
        <div *ngIf="tooltipParkingList.length === 0" class="no-parking">
          <span>{{ tooltipText }}</span>
        </div>
      </div>
    </div>
    <div class="tooltip-arrow"></div>
  </div>

  <ng-template #changePasswordDialog let-observer>
    <form tuiForm [formGroup]="changePasswordForm" (ngSubmit)="onPasswordSubmit(observer)" tuiForm="m">
      <header [tuiHeader]="'h6'">
        <p tuiSubtitle>Set a new password for <span style="font-weight: var(--semi-bold);">{{
            selectedMemberForPassword?.name }}</span>.</p>
      </header>

      <div class="stack">
        <tui-textfield>
          <label tuiLabel>New Password</label>
          <input formControlName="newPassword" placeholder="Enter new password" tuiPassword tuiTextfield
            type="password" />
          <tui-icon tuiPassword />
        </tui-textfield>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 0.25rem;">
          <tui-error formControlName="newPassword"
            [error]="(changePasswordForm.get('newPassword')?.touched || changePasswordForm.get('newPassword')?.dirty) ? 
                   (changePasswordForm.get('newPassword')?.hasError('required') ? 'New Password is required' : 
                    changePasswordForm.get('newPassword')?.hasError('minlength') ? 'Password must be at least 8 characters' : null) : null" />
          <button appearance="secondary" size="xs" tuiButton type="button" (click)="generatePassword()">
            Generate Password
          </button>
        </div>
      </div>

      <footer>
        <button appearance="flat" tuiButton type="button" (click)="observer.complete()">
          Cancel
        </button>
        <button tuiButton type="submit">
          Confirm
        </button>
      </footer>
    </form>
  </ng-template>

</main>